module.exports = __webpack_public_path__ + "img/Shiba-BG.1413ae9b.jpg";